// 問卷庫模塊
export default {
    QuesLibrary: {
        QuestionnaireType: '問卷類型',
        TemplatSistem: '系統模板',
        TemplatSaya: '我的模板',
        BankSoalanSaya: '我的題庫',
        BankSoalanSistem: '系統題庫',
        QuestionBankAnalysis: '題庫分析',
        LabelMasalah: '問題標簽',
        PengurusanMasalah: '問題管理',
        Tambah: '添加',
        Name: '名稱',
        SortOrder: '排序順序',
        Operate: '操作',
        AreYouSureToDeleteIt: '確定刪除嗎？',
        Delete: '刪除',
        Edit: '編輯',
        NewlyAdded: '新增',
        ModifySortingPosition: '修改排序位置',
        Category: '所屬分類',
        SortPosition: '排序位置',
        PleaseEnterAName: '請輸入名稱',
        SelectCategory: '選擇所屬分類',
        PleaseSelectCategory: '請選擇所屬分類',
        All: '全部',
        QuestionnaireName: '問卷名稱',
        NumberOfCitations: '引用次數',
        Type: '所屬類型',
        DesignQuestionnaire: '設計問卷',
        Preview: '預覽',
        Modify: '修改',
        MyTemplate: '我的模板',
        CannotExceed5MB: '上傳文件大小不能超過 5MB，請重新選擇圖片！',
        PleaseUploadPictures: '請上傳圖片',
        QuestionBankList: '題庫列表',
        NumberOfRecords: '記錄條數',
        Refresh: '刷新',
        SearchQuestionBankName: '請輸入要搜索的題庫名稱',
        SearchQuestionBankCategories: '請輸入要搜索的題庫類別',
        Query: '查詢',
        CreateANewQuestionBank: '新建題庫',
        QuestionBankNumber: '題庫編號',
        None: '暫無',
        QuestionBankName: '題庫名稱',
        QuestionBankCategory: '題庫類別',
        Creator: '創建人',
        NumberOfTestQuestions: '試題數',
        Memo: '備註信息',
        CreateQuestion: '創建問題',
        EditQuestion: '編輯問題',
        EditQuestionBank: '編輯題庫',
        AddQuestionBank: '添加題庫',
        QuestionBankInfo: '題庫信息',
        ConfirmDeletionOfQuestionBank: '確定刪除該題庫嗎？',
        SelectTheQuestionBankToDelete: '請先選擇要刪除的題庫',
        DeletSelectedQuestionBank: '確定刪除已選中的題庫嗎?',
        CancelTheSelectedQuestionBank: '確定取消已選中的題庫嗎？',
        CancelFavorite: '取消收藏',
        Prompt: '提示',
        ChooseAQuestionBankToBookmark: '請先選擇要收藏的題庫',
        CanceledSuccessfully: '取消成功',
        QuestionBankNumberLimit: '1-32個字符，使用字母、數字、下劃線',
        EnterOrSelectArticleLabel: '輸入/選擇文章標簽',
        Notes: '備註',
        Save: '保存',
        Resetting: '重置',
        CharacterMismatch: '請使用字母、數字、下劃線',
        LengthMismatch: '長度在 1 到 32 個字符',
        EnterTheNameOfTheQuestionBank: '請輸入題庫名稱',
        EnterQuestionBankCategory: '請輸入題庫類別',
        EnterQuestionBankNotes: '請輸入題庫備註',
        SelfBuiltQuestionBank: '自建題庫',
        DeleteQuestionBankFromFavoritesList: '確定從收藏列表刪除該題庫嗎？',
        ChooseToCancelTheFavoriteQuestionBank: '請先選擇要取消收藏的題庫',
        QuestionLabelName: '問題標簽名稱',
        AddQuestionLabel: '添加問題標簽',
        TagName: '標簽名稱',
        ModifyProblemLabels: '修改問題標簽',
        DeleteTitleTip: '刪除後將刪除分組內所有題目',
        DeleteConfirmation: '刪除確認',
        ExportData: '導出數據',
        NumberOfRespondents: '回答人數',
        NumberOfRespondents: '答題人數',
        Download: '下載',
        LoadMore: '加載更多',
        ModificationPrompt: '修改提示',
        ConfirmModifyingTheQuestionnaire: '您確認修改此問卷嗎？該問卷所有數據收集將被停止，答卷鏈接暫時關閉！',
        DataType: '數據類型',
        RawData: '原始數據',
        CodedData: '編碼數據',
        ExhibitionFormat: '展出形式',
        OneQuestionOneColumn: '一題一列',
        OneQuestionWithMultipleColumns: '一題多列',
        Export: '導 出',
        CustomTitle: '自定義標題',
        Pie: '餅圖',
        Histogram: '柱狀圖',
        BarChart: '條形圖',
        Ring: '圓環',
        StackedBarChart: '堆積柱狀圖',
        StackedBarChart2: '堆積條形圖',
        RadarChart: '雷達圖',
        ProblemList: '問題列表',
        MultipleChoiceBank: '請選擇題庫',
        EnterQuestionName: '請輸入問題名稱',
        EnterQuestionnaireLabel: '請輸入問卷標簽',
        ConfirmDeletionSelectedIssues: '確定刪除已選中的問題嗎？',
        IssueNames: '問題名稱',
        AffiliatedQuestionBank: '所屬題庫',
        QuestionnaireLabel: '問卷標簽',
        AreYouSureToDeleteTheIssue: '確定刪除該問題嗎？',
        Easy: '易',
        Easier: '較易',
        Middle: '中',
        RelativelyDifficult: '較難',
        Difficult: '難',
        NoLimit: '不限',
        Radio: '單選',
        SelectTheQuestionToDelete: '請先選擇要刪除的問題',
        TestQuestionManagement: '試題管理',
        EditItem: '編輯試題',
        Success: '成功'
    },
  };